import axios from 'axios'

import _get from 'lodash/get'

export default {
  namespaced: true,

  state: {
    events: [],
    event: null,
    count: 1
  },

  mutations: {},

  getters: {},

  actions: {
    async createCSV ({ state }, params) {
      try {
        const response = await axios.post('/import', params)
        const timeout = _get(response, 'data')
        console.log(timeout)
        return _get(response, 'status')
      } catch (err) {
        console.log(err.response)
      }
    }
  }
}
